export default {
  LOADING_GET_EXCHANGE_HISTORY: 'LOADING_GET_EXCHANGE_HISTORY',
  SUCCESS_GET_EXCHANGE_HISTORY: 'SUCCESS_GET_EXCHANGE_HISTORY',
  ERROR_GET_EXCHANGE_HISTORY: 'ERROR_GET_EXCHANGE_HISTORY',

  LOADING_GET_EXCHANGE_SETTINGS: 'LOADING_GET_EXCHANGE_SETTINGS',
  SUCCESS_GET_EXCHANGE_SETTINGS: 'SUCCESS_GET_EXCHANGE_SETTINGS',
  ERROR_GET_EXCHANGE_SETTINGS: 'ERROR_GET_EXCHANGE_SETTINGS',

  SAVE_EXCHANGE_SETTINGS: 'SAVE_EXCHANGE_SETTINGS',
} as const;
